export default "__VITE_ASSET__DJDHMn3l__"